module.exports = __webpack_public_path__ + "static/media/store_img_4.c534a32d.png";